// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/current_active_shift.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ShiftDetails } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CurrentActiveShiftRequest
 */
export class CurrentActiveShiftRequest extends Message<CurrentActiveShiftRequest> {
  constructor(data?: PartialMessage<CurrentActiveShiftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CurrentActiveShiftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CurrentActiveShiftRequest {
    return new CurrentActiveShiftRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CurrentActiveShiftRequest {
    return new CurrentActiveShiftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CurrentActiveShiftRequest {
    return new CurrentActiveShiftRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CurrentActiveShiftRequest | PlainMessage<CurrentActiveShiftRequest> | undefined, b: CurrentActiveShiftRequest | PlainMessage<CurrentActiveShiftRequest> | undefined): boolean {
    return proto3.util.equals(CurrentActiveShiftRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CurrentActiveShiftResponse
 */
export class CurrentActiveShiftResponse extends Message<CurrentActiveShiftResponse> {
  /**
   * @generated from field: bool currently_active = 1;
   */
  currentlyActive = false;

  /**
   * @generated from field: bool last_active_shift_present = 2;
   */
  lastActiveShiftPresent = false;

  /**
   * @generated from field: com.neulink.pharmacy.ShiftDetails last_active_shift = 3;
   */
  lastActiveShift?: ShiftDetails;

  /**
   * @generated from field: com.neulink.pharmacy.ShiftDetails current_active_shift = 4;
   */
  currentActiveShift?: ShiftDetails;

  constructor(data?: PartialMessage<CurrentActiveShiftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CurrentActiveShiftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currently_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "last_active_shift_present", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "last_active_shift", kind: "message", T: ShiftDetails },
    { no: 4, name: "current_active_shift", kind: "message", T: ShiftDetails },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CurrentActiveShiftResponse {
    return new CurrentActiveShiftResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CurrentActiveShiftResponse {
    return new CurrentActiveShiftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CurrentActiveShiftResponse {
    return new CurrentActiveShiftResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CurrentActiveShiftResponse | PlainMessage<CurrentActiveShiftResponse> | undefined, b: CurrentActiveShiftResponse | PlainMessage<CurrentActiveShiftResponse> | undefined): boolean {
    return proto3.util.equals(CurrentActiveShiftResponse, a, b);
  }
}

